export default "https://cdn-static.gokick.com/assets/6600ddf3ffcd3e3653ecf6807c0977bcbaa0931f/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";